import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { setAnalyticsChoice, getStoredConsent } from "@/lib/analytics";


export const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    if (!getStoredConsent()) setShowBanner(true);
    // GA bootstrap + consent restore is handled centrally in App.tsx
  }, []);

  // Let other floating UI (e.g. the Feedback button) move out of the way.
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("bb:cookie-banner", { detail: showBanner }));
  }, [showBanner]);

  const handleAcceptAll = () => {
    setAnalyticsChoice(true);
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    setAnalyticsChoice(false);
    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-[72px] md:bottom-0 left-0 right-0 z-40 animate-in slide-in-from-bottom duration-300">
      <div className="bg-card/95 backdrop-blur-md border-t border-border shadow-soft">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1 flex items-start gap-3">
              <span className="text-2xl">🍪</span>
              <div className="text-sm text-foreground space-y-1">
                <p className="font-medium">We use cookies to keep you logged in and remember your preferences.</p>
                <p className="text-muted-foreground">
                  Optional Google Analytics only runs if you click Accept All. We don't use advertising cookies.
                </p>
              </div>
            </div>
            
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <Button
                onClick={handleRejectAll}
                variant="outline"
                size="sm"
                className="flex-1 sm:flex-none"
              >
                Reject All
              </Button>
              <Button
                onClick={handleAcceptAll}
                size="sm"
                className="bg-primary hover:bg-primary/90 text-primary-foreground flex-1 sm:flex-none"
              >
                Accept All
              </Button>
              <Button
                asChild
                variant="ghost"
                size="sm"
                className="hidden sm:inline-flex"
              >
                <Link to="/cookie-policy">Cookie Policy →</Link>
              </Button>
              <Button
                onClick={handleClose}
                variant="ghost"
                size="icon"
                className="h-8 w-8"
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
          
          <Link 
            to="/cookie-policy" 
            className="sm:hidden text-xs mt-2 inline-block no-underline"
          >
            Learn more about our Cookie Policy →
          </Link>
        </div>
      </div>
    </div>
  );
};